<template>
	<div :class="!selectable ? 'spaces px-12 pt-5' : null">
		<NavBar v-if="!selectable" :admin="true" :items="items" />
		<v-main :class="selectable ? 'pa-0' : null">
			<v-container fluid>
				<v-simple-table v-if="!selectable">
					<template v-slot:default>
						<thead>
							<tr>
								<th class="text-left">Nº Espaços</th>
								<th class="text-left">Nº Utilizadores</th>
								<th class="text-left">Nº Pacientes</th>
								<th class="text-left">Nº Consultas</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{{ spaces.length }}</td>
								<td>{{ num_users }}</td>
								<td>{{ num_patients }}</td>
								<td>{{ num_appointments }}</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
				<v-row no-gutters class="mt-3">
					<v-col>
						<v-menu
							v-model="dateMenu"
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
							min-width="290px"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									dense
									solo
									v-model="dates"
									label="Intervalo da data de criação"
									append-icon="event"
									readonly
									v-on="on"
									class="px-2"
								></v-text-field>
							</template>
							<v-date-picker range color="primary" v-model="dates" @input="dates[1] ? dateMenu = false : null"></v-date-picker>
						</v-menu>
					</v-col>
					<v-col>
						<v-select
							dense
							solo
							item-text="name"
							item-value="id"
							:items="subscriptionPlans"
							v-model="selectedPlans"
							hide-details
							multiple
							return-object
							label="Planos"
						>
						</v-select>
					</v-col>
					<v-col>
						<v-select
							dense
							solo
							item-text="name"
							item-value="id"
							:items="specialities"
							v-model="selectedSpecialities"
							hide-details
							multiple
							return-object
							label="Especialidades"
							class="px-2"
						>
						</v-select>
					</v-col>
				</v-row>
				<v-text-field
					v-model="search"
					prepend-inner-icon="search"
					placeholder="Procurar Espaço..."
					single-line
					outlined
					solo
					class="mt-5"
					hide-details
				></v-text-field>
				<v-row no-gutters>
					<v-spacer></v-spacer>
					<span class="font-weight-bold mr-2">{{spacesFiltered.length}}</span>
				</v-row>
				<v-data-table
					disable-pagination
					fixed-header
					item-key="id"
					:headers="headers"
					:items="spacesFiltered"
					:search="search"
					hide-default-footer
					class="mb-5 row-pointer"
					:loading="loading"
					:show-select="selectable"
					v-model="selectedSpaces"
					@click:row="clickSpace"
				>
					<template v-slot:item.plan="{ item }">
						<v-row no-gutters align="center">
							{{ getPlanName(item.subscription_plan) }}
							<v-spacer></v-spacer>
							<v-btn icon @click.stop.prevent="getSpaceInfo(item)">
								<v-icon small>mdi-information</v-icon>
							</v-btn>
						</v-row>
					</template>
				</v-data-table>
				<v-dialog v-if="space" v-model="showSpaceInfo" max-width="40%">
          <v-card>
						<v-card-title class="title primary--text mb-2 secondary">{{space.space_name}}</v-card-title>
						<v-card-text>
							<template v-if="space.subscription_plan">
								<p>Plano: {{space.subscription_plan.plan.name}}</p>
								<p>Início: {{space.subscription_plan_start_date}}</p>
								<p>Fim: {{space.subscription_plan_end_date}}</p>
							</template>
							<p v-else>Sem plano.</p>
						</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<v-btn color="primary" text @click="showSpaceInfo = false"><translate>Close</translate></v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
			</v-container>
		</v-main>
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import axios from "axios";

export default {
	name: "Spaces",
	props: ["selectable"],
	components: {
		NavBar
	},
	data: () => ({
		loading: true,
		spaces: [],
		num_users: [],
		num_patients: [],
		num_appointments: [],
		search: null,
		headers: [
			{ text: "#", value: "n" },
			{ text: "Nome", value: "space_name" },
			{ text: "Email", value: "email" },
			{ text: "Nº Profissionais", value: "num_users" },
			{ text: "Nº Pacientes", value: "num_patients" },
			{ text: "Nº Consultas", value: "num_appointments" },
			{ text: "Plano", value: "plan" }
		],
		showSpaceInfo: false,
		space: null,
		subscriptionPlans: [],
		selectedPlans: [],
		specialities: [],
		selectedSpecialities: [],
		dateMenu: false,
		dates: null,
		selectedSpaces: []
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Spaces"),
					disabled: true,
					link: true
				}
			];
		},
		spacesFiltered() {
			let spacesFiltered = this.spaces;
			
			if(this.selectedPlans.length > 0) {
				spacesFiltered = this.spaces.filter(s => {
					if(s.subscription_plan) {
						let exist = false;
						this.selectedPlans.forEach(sp => {
							if(sp.code == s.subscription_plan.plan.code) exist = true;
						});
						if(exist) return true;
					}
					return false;
				});
			}

			if(this.dates && this.dates.length == 2) {
				spacesFiltered = spacesFiltered.filter(s => {
					if(s.manager) {
						let startDate = new Date(this.dates[0]);
						let finalDate = new Date(this.dates[1]);
						let createdDate = new Date(s.manager.created);
						if(createdDate >= startDate && createdDate <= finalDate) return true;
						else return false;
					}
				});
			}

			if(this.selectedSpecialities.length > 0) {
				spacesFiltered = spacesFiltered.filter(s => {
					if(s.specialities.length > 0) {
						let exist = false;
						this.selectedSpecialities.forEach(sp => {
							s.specialities.forEach(space_sp => {
								if(space_sp.id == sp.id) exist = true;
							});
						});
						if(exist) return true;
					}
					return false;
				});
			}

			return spacesFiltered;
		}
	},
	methods: {
		clickSpace(space) {
			if(!this.selectable && this.$store.getters.isSuperAdmin) this.$router.push({name: "manage-space", params: { sid: space.id }});
		},
		getSpaceInfo(space) {
			this.space = space;
			this.showSpaceInfo = true;
		},
		getPlanName(plan_info) {
			if(plan_info) {
				let name = `${plan_info.plan.name}${plan_info.plan.custom ? '*' : ''}`;
				let expiration = plan_info.days_left == 0 ? ' (Expirado)' : ` (${plan_info.days_left} dias)`;
				return name + expiration;
			}
			else return 'N/D';
		},
		getSelectedEmails() {
			let selectedEmails = [];
			for(let i=0; i < this.selectedSpaces.length; i++) {
				selectedEmails.push({email: this.selectedSpaces[i].manager.email, lang: this.selectedSpaces[i].manager.lang});
			}
			return selectedEmails;
		}
	},
	created() {
		axios
			.get("/admin/dashboard/spaces")
			.then(response => {
				console.log(response.data);
				this.spaces = Object.values(response.data.spaces);
				this.num_users = response.data.num_users;
				this.num_patients = response.data.num_patients;
				this.num_appointments = response.data.num_appointments;
				this.loading = false;

				this.spaces.forEach((s, i) => {
					if(s.subscription_plan) {
						let index = this.subscriptionPlans.findIndex(sp => sp.code == s.subscription_plan.plan.code);
						if(index == -1) this.subscriptionPlans.push(s.subscription_plan.plan);
					}
					if(s.specialities.length > 0) {
						s.specialities.forEach(spec => {
							let index = this.specialities.findIndex(sp => sp.id == spec.id);
							if(index == -1) this.specialities.push(spec);
						})
					}

					s.n = i + 1;
					s.space_name = s.manager && s.manager.student ? s.manager.school + ' (Estudante)' : s.space_name + `${s.provider ? ' (Fornecedor)' : ''}`;
					s.email = s.manager ? s.manager.email : 'N/D';
				})
			})
			.catch(error => console.log(error));
	}
};
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>